import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from "./contexts/UserContext";
import { AuthProvider } from "./contexts/AuthProvider";
import AppContent from "./AppContent";
import ThemeContextProvider from "./theme/ThemeContext";

import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { messages as enMessages } from "./locales/en/messages.js";
import { messages as trMessages } from "./locales/tr/messages.js";
import { compileMessage } from "@lingui/message-utils/compileMessage";


// Load and activate Lingui
i18n.load({
  en: enMessages,
  tr: trMessages,
});

i18n.activate("tr");

console.log("1.0.0" + process.env.REACT_APP_BUILD_ID);

console.log("localisation loaded");

export default function App() {
  return (
    <I18nProvider i18n={i18n}>
      <UserProvider>
        <AuthProvider>
          <Router>
            <ThemeContextProvider>
              <AppContent />
            </ThemeContextProvider>
          </Router>
        </AuthProvider>
      </UserProvider>
    </I18nProvider>
  );
}
